import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress, Grid2 } from "@mui/material";
import styles from "./NewPlanSignupStyle.module.scss";
import SignUpPlan from "../SignUpPlan/SignUpPlan";
import SignUpAddon from "../SignUpAddon/SignUpAddon";
import SignUpPlanSummary from "../SignUpPlanSummary/SignUpPlanSummary";
import { ReactComponent as AddonIcon } from "../../../../GlobalAssets/svg/addon_signup.svg";
import { Actions } from "../../../../redux/constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import { planIcon } from "../../../../Utils/planIcons";
import axios from "axios";
import CreateAccount from "../CreateAccount/CreateAccount";
import {
  convertToYearlyPrice,
  formatIndianCurrency,
  useEmailId,
  verifyEmail,
  verifyPassword,
} from "../../../../Utils/utils";
import CreateOrgSignup from "../CreateOrgSignup/CreateOrgSignup";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { INVITE_ROLES } from "../../../../Utils/Roles";
import CreateAccountBilling from "../CreateAccountBilling/CreateAccountBilling";
import OrgOverviewPageLoading from "../../../../GlobalComponents/OrgOverviewPageLoading/OrgOverviewPageLoading";
import CongnitoServices from "../../../../redux/Services/cognitoServices";
import zipcodes from "zipcodes";
import { countryStateData } from "../../../../Utils/countryStateData";
// import { cashfreeSubscriptionSessionIdDecrypt } from "../../../../Utils/cashfree";
import { load } from "@cashfreepayments/cashfree-js";
import { resendSignUpCode } from "aws-amplify/auth";
import { useSelector } from "react-redux";
import AuthContext from "../../../../store/auth-context";
import ModalPopup from "../../../../GlobalComponents/Popup/ModalPopup";
import { ReactComponent as IndPaymentIcon } from "../../../Admin/AdminAssets/svg/indPayment.svg";
import { ReactComponent as PointRight } from "../../../Admin/AdminAssets/svg/point-right.svg";
import ConfigureContext from "../../../../store/ConfigureContext";

function NewPlanSignup() {
  const location = useLocation();
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const [step, setStep] = useState(1);
  const [error, setError] = useState(false);
  const [otpError, setOtpError] = useState(null);
  const [emailError, setEmailError] = useState(false);
  const [isSignUpError, setIsSignUpError] = useState(false);
  const [captchaToken, setCaptchaToken] = useState();
  const [recaptcha, setRecaptcha] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [plansInfo, setPlansInfo] = useState(null);
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState("");
  const [couponLoading, setCouponLoading] = useState(false);
  const [couponError, setCouponError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [planLoading, setPlanLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [verified, setVerified] = useState(false);
  const [billingInValid, setBillingInvalid] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [verifyError, setVerifyError] = useState(false);
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMessage, setResendMessage] = useState("");
  const [isIndPayment, setIsIndPayment] = useState(false);
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);
  const [yearlyPrice, setYearlyPrice] = useState(0);
  const [indDiscount, setIndDiscount] = useState(0);
  const [gst, setGst] = useState(0);
  const [pfAmount, setPfAmount] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [isData, setIsData] = useState(null);
  const [showInput, setShowInput] = useState(false);
  const [showMembers, setShowMembers] = useState(false);
  const { currentUser } = useContext(AuthContext);
  // const emailId = currentUser?.tokens?.signInDetails.loginId;
  const emailId = useEmailId();

  useEffect(() => {
    if (currentUser) {
      getStore().dispatch({ type: Actions.API_USER_DETAILS });
      getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
      getStore().dispatch({ type: Actions.API_CHECK_USER_HAS_PLAN });
    }
  }, [currentUser]);

  useEffect(() => {
    if (emailId) {
      setValues((prev) => ({
        ...prev,
        email: emailId,
        emailState: "success",
      }));
      setIsCreateOrg(true);
    }
  }, [emailId]);

  const hasPlanData = useSelector((state) => state?.users?.hasPlan);
  const userDetails = useSelector((state) => state.users?.userDetails);

  const [isCreateOrg, setIsCreateOrg] = useState(
    emailId === undefined ? false : true,
  );
  const [createOrg, setCreateOrg] = useState(false);
  const [selectOrg, setSelectOrg] = useState(false);
  const [isBilling, setIsBilling] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [nameValid, setNameValid] = useState(false);
  const [orgId, setOrgId] = useState("");
  const [explorePlans, setExplorePlans] = useState(false);

  // Parse URL params early
  const urlParams = new URLSearchParams(location?.search);
  const isSingleSiteParam = urlParams?.get("singleSitePlan") || false;

  // Check if single site parameter is true
  const isSingleSite =
    typeof isSingleSiteParam === "string"
      ? isSingleSiteParam?.toLowerCase() === "true"
      : false;

  const [planType, setPlanType] = useState(isSingleSite ? "solo" : "multi");

  const [toggleType, setToggleType] = useState("yearly");
  const [newPlan, setNewPlan] = useState(null);
  const [selectedPlanDetails, setSelectedPlanDetails] = useState({
    billingCycle: "Yearly",
    planPrice: 0,
  });
  const [isPlanSelected, setIsPlanSelected] = useState(false);

  const roleOptions = INVITE_ROLES.map((role) => ({
    value: role.roleId,
    label: role.displayName,
  }));

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const stringToBoolean = (value) => {
    if (typeof value === "string") {
      return value?.toLowerCase() === "true";
    }
    return false;
  };

  const normalizeBillingCycle = (cycle) => {
    if (!cycle) return "Yearly";
    const normalized = cycle.toLowerCase();
    return normalized === "monthly" || normalized === "yearly"
      ? normalized.charAt(0).toUpperCase() + normalized.slice(1)
      : "Yearly";
  };

  // Derive billingCycle: prioritize URL param unless plan is selected
  const isDedicatedParam = urlParams?.get("isDedicated");
  const isDedicated = isDedicatedParam?.toLowerCase() === "true";
  const [hostingType, setHostingType] = useState(
    isDedicated ? "dedicated" : "kubernetes",
  );

  const billingCycle = isPlanSelected
    ? normalizeBillingCycle(selectedPlanDetails?.billingCycle)
    : normalizeBillingCycle(urlParams.get("billingCycle"));
  const planName = newPlan
    ? newPlan?.planName
    : urlParams?.get("planName") || "LaunchPad";

  const singleSite =
    newPlan === null
      ? stringToBoolean(isSingleSiteParam)
      : newPlan?.singleSitePlan;

  const userCountry =
    userDetails?.country !== null && userDetails?.country !== undefined
      ? userDetails.country
      : "USA";

  const [country, setCountry] = useState(
    userDetails ? userCountry : urlParams?.get("country") || "USA",
  );

  let formattedCountry;

  if (country?.toLowerCase() === "usa") {
    formattedCountry = country.toUpperCase();
  } else if (country?.toLowerCase() === "india") {
    formattedCountry =
      country.charAt(0).toUpperCase() + country.slice(1).toLowerCase(); // "India"
  } else {
    formattedCountry = "USA";
  }

  const [values, setValues] = useState({
    email: "",
    emailState: "error",
    emailErrorMessage: "Email is required",

    name: "",
    nameState: "error",
    nameErrorMessage: "Name is Required",

    phoneNumber: "",
    phoneNumberState: "error",
    phoneNumberErrorMessage: "Please enter a valid phone number",

    password: "",
    passwordState: "error",
    passwordErrorMessage: "Password is Required",

    tos: false,
    country: formattedCountry || "USA",
    zipCode: "",
    state: "",
    city: "",
    address: "",
  });

  const [orgForm, setOrgForm] = useState({
    orgName: "",
    orgNameError: false,
    orgNameErrorMessage: "",
    members: [{ memberEmailId: "", roleId: "" }],
    memberError: [{ memberEmailIdError: false, roleIdError: false }],
    limitError: "",
    selectOrganization: {},
  });

  const [isAddress, setIsAddress] = useState(false);
  const [orgAddress, setOrgAddress] = useState(null);

  const organizationId = orgId ? orgId : orgForm?.selectOrganization?.value;

  const [billingForm, setBillingForm] = useState({
    address: "",
    addressNameError: false,
    addressNameErrorMessage: "Address is required",
    country: formattedCountry || "USA",
    countryError: false,
    countryErrorMessage: "",
    states: countryStateData[formattedCountry],
    state: "",
    stateError: false,
    stateErrorMessage: "State is required",
    city: "",
    cityError: false,
    cityErrorMessage: "City is required",
    zipCode: "",
    zipCodeError: false,
    zipCodeErrorMessage: "Enter valid zipCode",
    comapnyName: "",
    companyNameError: false,
    comapnyNameErrorMessage: "",
    taxID: "",
    taxIdError: false,
    taxIdErrorMessage: "",
  });

  useEffect(() => {
    if (!orgForm?.selectOrganization?.value) return;
    if (orgForm?.selectOrganization?.value && isBilling && !createOrg) {
      setIsAddress(true);
      getStore().dispatch({
        type: Actions.API_GET_ORG_ADDRESS,
        data: { orgId: orgForm?.selectOrganization?.value },
        meta: {
          onSuccess: (data) => {
            setOrgAddress(data);
            setIsAddress(false);
          },
          onError: () => {
            setIsAddress(false);
          },
        },
      });
    }
  }, [isBilling, createOrg]);

  const isFullOrgAddress =
    orgAddress?.address &&
    orgAddress?.city &&
    orgAddress?.state &&
    orgAddress?.zipCode &&
    orgAddress?.country;

  const statesList =
    countryStateData[orgAddress?.country || formattedCountry] || [];
  const matchedState = statesList.find(
    (s) => s.value === orgAddress?.state || s.label === orgAddress?.state,
  );

  useEffect(() => {
    if (orgAddress) {
      setBillingForm((prev) => ({
        ...prev,
        address: orgAddress?.address || "",
        country: orgAddress?.country || "USA",
        city: orgAddress?.city || "",
        zipCode: orgAddress?.zipCode || "",
        states: statesList,
        state: matchedState?.value || matchedState?.label || "",
      }));
    }
  }, [orgAddress]);

  useEffect(() => {
    setCountry(billingForm.country || "USA");
    if (newPlan && !userDetails) {
      handleOnCancel();
    }
    if (newPlan) {
      setIndDiscount(0);
      setCouponCode("");
      setShowInput(false);
      setIsData(null);
    }
  }, [billingForm.country, newPlan]);

  useEffect(() => {
    if (userDetails) {
      const newCountry = userDetails.country || "USA";
      setCountry(newCountry);
      setBillingForm((prevForm) => ({
        ...prevForm,
        country: newCountry,
        states: countryStateData[newCountry] || [], // Update states based on the new country
      }));
    }
  }, [userDetails]);

  useEffect(() => {
    const filteredStates = countryStateData[billingForm.country] || [];
    // Only reset state if it's not in the new states list
    const isStateValid = filteredStates.some(
      (s) => s.value === billingForm.state || s.label === billingForm.state,
    );
    setBillingForm((prev) => ({
      ...prev,
      states: filteredStates,
      state: isStateValid ? prev.state : "",
    }));
  }, [billingForm.country]);

  const [inputErrorVar, setInputErrorVar] = useState({
    email: false,
    password: false,
    phoneNumber: false,
    name: false,
    tos: false,
    country: false,
    state: false,
    zipCode: false,
  });

  const orgData = useSelector((state) =>
    state.organizationsInfo?.dashboardOrg?.data?.filter(
      (org) => org.role === "ORG_OWNER" || org.role === "ORG_SUPER_ADMIN",
    ),
  );

  const PhoneNumberformat = (phoneNumber, country) => {
    // Remove all non-numeric characters
    const cleaned = phoneNumber.replace(/\D/g, "");

    if (country === "USA") {
      // Format for USA: (999) 999-9999
      if (cleaned.length <= 3) {
        return cleaned ? `(${cleaned}` : ""; // Remove `(` if empty
      } else if (cleaned.length <= 6) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3)}`;
      } else if (cleaned.length <= 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
          6,
        )}`;
      } else {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(
          6,
          10,
        )}`;
      }
    } else if (country === "India") {
      // Format for India: 99999-99999
      if (cleaned.length <= 5) {
        return cleaned;
      } else if (cleaned.length <= 10) {
        return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
      } else {
        return `${cleaned.slice(0, 5)}-${cleaned.slice(5, 10)}`;
      }
    }

    return cleaned;
  };

  const formFieldUpdate = (prop, value) => {
    let status = "error";
    let message = "";
    setEmailError(false);
    setVerifyError(false);
    setBillingInvalid(false);

    if (value === "") {
      status = "";
      message = "";
    } else {
      switch (prop) {
        case "email":
          value = value.replace(/\s/g, ""); // Remove all spaces
          setError(false);
          if (process.env.REACT_APP_TEMP_DOMAIN === "roconpaas.io") {
            // Remove plus symbol from email
            value = value.replace(/\+/g, "");
            value = value.replace(/\s/g, "");
          } else {
            value = value.replace(/\s/g, "");
          }
          if (verifyEmail(value)) {
            status = "success";
          } else {
            status = "error";
            message = "Please enter a valid email";
          }
          break;

        case "name":
          value = value.replace(/^\s+/, ""); // Remove leading spaces
          if (value.length < 3) {
            status = "error";
            message = "Name must be at least 3 characters long";
          } else {
            status = "success";
          }
          break;

        case "phoneNumber":
          value = value.replace(/\D/g, ""); // Allow only numeric values

          if (value.length > 10) {
            value = value.slice(0, 10);
          }

          if (value.length !== 10) {
            status = "error";
            message = "Invalid phone number";
          } else {
            status = "success";
          }
          break;

        case "password":
          if (!verifyPassword(value)) {
            status = "error";
            message =
              "Requires at least 8 characters with one capital letter, one numeric character, and one special character";
          } else {
            status = "success";
          }
          break;

        case "orgName":
          const newValue = value
            .replace(/[^a-zA-Z0-9\s]/g, "")
            .replace(/\s{2,}/g, " ")
            .replace(/^\s+/, "");
          value = newValue;
          setError(false);
          if (newValue.length < 3) {
            status = "error";
            message = "Organization name must be at least 3 characters long";
          } else if (newValue.length === 25) {
            status = "error";
            message = "Organization name must not exceed 24 characters";
          } else {
            status = "success";
          }
          break;

        // Billing form cases
        case "address":
          value = value.trimStart();
          if (value.length < 5) {
            status = "error";
            message = "Address must be at least 5 characters long";
          } else {
            status = "success";
          }
          break;

        case "country":
          if (billingForm.country !== value) {
            const filteredStates = countryStateData[value] || [];
            setBillingForm({
              ...billingForm,
              country: value || "USA",
              state: "",
              states: filteredStates,
              address: "",
              city: "",
              zipCode: "",
            });
            setShowInput(false);
            setCouponCode("");
            setIsData(null);
          }
          break;

        case "state":
          value = value.replace(/[^a-zA-Z]/g, "");
          if (value) {
            status = "success";
          } else {
            status = "error";
            message = "Please enter a valid state name";
          }
          break;

        case "city":
          value = value.trimStart();
          if (!/^[A-Za-z\s]+$/.test(value)) {
            status = "error";
            message = "City must contain only letters";
          } else if (value.length < 2) {
            status = "error";
            message = "City must be at least 2 characters long";
          } else {
            status = "success";
          }
          break;

        case "zipCode":
          value = value.replace(/[^0-9]/g, "");
          if (value.length > 8) {
            value = value.slice(0, 8);
          }
          if (value.length > 4) {
            status = "success";
          } else {
            status = "error";
            message = "Please enter a valid zip code";
          }
          break;

        case "companyName":
          value = value.trim();
          if (value.length < 3) {
            status = "error";
            message = "Company name must be at least 3 characters long";
          } else {
            status = "success";
          }
          break;

        case "taxID":
          value = value.trim();
          if (value.length < 5) {
            status = "error";
            message = "Tax ID must be at least 5 characters long";
          } else {
            status = "success";
          }
          break;

        default:
          break;
      }
    }

    setInputErrorVar({ ...inputErrorVar, [prop]: status === "error" });

    if (prop in billingForm) {
      setBillingForm((prevForm) => ({
        ...prevForm,
        [prop]: value,
        [`${prop}Error`]: status === "error",
        [`${prop}ErrorMessage`]: message,
      }));
    } else if (prop === "orgName") {
      setOrgForm({
        ...orgForm,
        orgName: value,
        orgNameError: status === "error",
        orgNameErrorMessage: message,
      });
    } else {
      setValues({
        ...values,
        [prop]: value,
        [`${prop}State`]: status,
        [`${prop}ErrorMessage`]: message,
      });
    }
  };

  const handleOtpChange = (index, value) => {
    setResendMessage("");
    setOtpError(null);
    const numericValue = value.replace(/\D/g, "");
    const updatedOtp = [...otp];
    updatedOtp[index] = numericValue;
    setOtp(updatedOtp);

    // Automatically focus on the next input if the current one is filled
    if (numericValue && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, event) => {
    if (event.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (event.key === "ArrowLeft" && index > 0) {
      event.preventDefault();
      let targetIndex = index - 1;

      // Move to the nearest left non-empty field
      while (targetIndex > 0 && !otp[targetIndex]) {
        targetIndex--;
      }

      inputRefs.current[targetIndex]?.focus();
    } else if (event.key === "ArrowRight" && index < 5) {
      event.preventDefault();
      let targetIndex = index + 1;

      // Move to the nearest right non-empty field
      while (targetIndex < 6 && !otp[targetIndex]) {
        targetIndex++;
      }

      if (targetIndex < 6) {
        inputRefs.current[targetIndex]?.focus();
      }
    }
  };

  const validateZipCode = (zipCode, country) => {
    if (
      !(
        (billingForm.country === "India" && billingForm.zipCode.length >= 6) ||
        (billingForm.country === "USA" && billingForm.zipCode.length >= 5)
      )
    )
      return false;

    let isValid = false;

    if (country === "USA") {
      const zipData = zipcodes.lookup(zipCode);
      isValid = !!zipData;
    } else if (country === "India") {
      const indiaZipCodeRegex = /^[1-9]{1}[0-9]{5,7}$/;
      isValid = indiaZipCodeRegex.test(zipCode);
    }

    return isValid;
  };

  const isBillingValid =
    billingForm.address &&
    billingForm.country &&
    billingForm.state &&
    billingForm.city &&
    ((billingForm.country === "India" && billingForm.zipCode.length >= 6) ||
      (billingForm.country !== "India" && billingForm.zipCode.length >= 5)) &&
    validateZipCode(billingForm.zipCode, billingForm.country) &&
    !billingForm.addressNameError &&
    !billingForm.stateError &&
    !billingForm.cityError &&
    !billingForm.zipCodeError;

  const isDisabled =
    step === 1 && orgForm.orgName === "" && isBillingValid
      ? false
      : !isFullOrgAddress
        ? !isBillingValid
        : !(
            orgAddress?.address &&
            orgAddress?.city &&
            orgAddress?.state &&
            orgAddress?.zipCode &&
            orgAddress?.country
          ) || !isBilling;

  const isVerifyDisabled =
    !values.name ||
    !values.phoneNumber ||
    !values.email ||
    !values.password ||
    !isChecked ||
    !recaptcha ||
    values.nameState === "error" ||
    values.phoneNumberState === "error" ||
    values.emailState === "error" ||
    values.passwordState === "error";

  const handleSendOtp = () => {
    const requiredFields = ["email", "name", "phoneNumber", "password", ""];

    requiredFields.forEach((field) => {
      formFieldUpdate(field, "");
    });

    if (isVerifyDisabled) {
      setVerifyError(true);
    } else
      try {
        setVerifying(true);
        setVerifyError(false);
        axios
          .get(
            `${
              process.env.REACT_APP_BACK_END_API_BASE_URL
            }/users/doesUserExists?userEmail=${encodeURIComponent(
              values.email,
            )}&userPoolId=${cognitoId}`,
          )
          .then((response) => {
            if (response.data === true) {
              setEmailError(true);
            } else {
              try {
                setIsOtpSent(true);
                const res = CongnitoServices.signUpForm(values, captchaToken);
                setLoading(false);
                if (res === true) {
                  setIsOtpSent(true);
                  setVerified(true);
                } else if (res) {
                  setIsSignUpError(res);
                } else {
                  setError("An unexpected error occurred. Please try again.");
                }
              } catch (error) {
                setLoading(false);
                setError("Failed to signup. Please try again.");
              }
            }
            setVerifying(false);
          })
          .catch(() => {
            setVerifying(false);
            setVerified(false);
          });
      } catch (e) {
        setVerifying(false);
      }
  };

  const resendOtp = async () => {
    setResendMessage("");
    setOtpError(null);
    setResendLoading(true);
    try {
      await resendSignUpCode({ username: values.email });
      setOtp(new Array(6).fill(""));
      inputRefs.current.forEach((input) => {
        if (input) input.value = "";
      });
      setError(null);
      setResendMessage("OTP resent successfully!");
      setResendLoading(false);
      setTimeout(() => {
        setResendMessage("");
      }, 5000);
    } catch (e) {
      setResendLoading(false);
    }
  };

  const { cognitoId } = useContext(ConfigureContext);

  const handleVerifyAccount = () => {
    try {
      setVerifying(true);
      axios
        .post(
          `${
            process.env.REACT_APP_BACK_END_API_BASE_URL
          }/users/isUserExistsAndVerifiedInCognito?userEmail=${encodeURIComponent(
            values.email,
          )}&userPoolId=${cognitoId}`,
        )
        .then((response) => {
          if (response.data === true) {
            setIsCreateOrg(true);
          } else {
            setError(true);
          }
          setVerifying(false);
        })
        .catch((error) => {
          setVerifying(false);
        });
    } catch (e) {
      setVerifying(false);
    }
  };

  const submitHandler = async () => {
    setError(null);
    setOtpError(null);
    setVerifying(true);
    try {
      const cognitoResponse = await CongnitoServices.verifyEmail({
        email: values.email,
        verificationCode: otp.join(""),
      });
      if (cognitoResponse) {
        handleVerifyAccount();
      } else {
        setOtpError("The entered OTP is incorrect");
      }
    } catch (e) {
      setOtpError("An error occurred. Please try again.");
    } finally {
      setVerifying(false);
    }
  };

  const orgNameRequestId = useRef(0);

  useEffect(() => {
    // Debounce org name validation: only validate after user stops typing for 500ms
    if (orgForm.orgName === "") {
      setOrgForm((prev) => ({
        ...prev,
        orgNameError: false,
        orgNameErrorMessage: "",
      }));
      setNameValid(false);
      return;
    }

    if (orgForm.orgName.length < 4) {
      setOrgForm((prev) => ({
        ...prev,
        orgNameError: true,
        orgNameErrorMessage: "Organization name must be at least 4 characters",
      }));
      setNameValid(false);
      return;
    }

    setNameLoading(true);
    orgNameRequestId.current += 1;
    const currentRequest = orgNameRequestId.current;

    const handler = setTimeout(() => {
      axios
        .get(
          `${process.env.REACT_APP_BACK_END_API_BASE_URL}/organizations/isValidOrgNameAtSignup?orgName=${orgForm.orgName}`,
        )
        .then((response) => {
          if (currentRequest !== orgNameRequestId.current) return; // Ignore outdated responses
          if (response.data === false) {
            setOrgForm((prev) => ({
              ...prev,
              orgNameError: true,
              orgNameErrorMessage: "Organization Already Exists!",
            }));
            setNameValid(false);
          } else {
            setOrgForm((prev) => ({
              ...prev,
              orgNameError: false,
              orgNameErrorMessage: "",
            }));
            setNameValid(true);
          }
          setNameLoading(false);
        })
        .catch(() => {
          if (currentRequest !== orgNameRequestId.current) return;
          setNameLoading(false);
        });
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [orgForm.orgName]);

  const handleCreateOrg = () => {
    if (orgForm.orgName !== "") {
      try {
        setCreating(true);
        const filteredMembers = Array.isArray(orgForm.members)
          ? orgForm.members.filter(
              (member) =>
                member.memberEmailId?.trim() !== "" &&
                `${member.roleId}`.trim() !== "", // Convert roleId to a string safely
            )
          : [];

        axios
          .post(
            `${process.env.REACT_APP_BACK_END_API_BASE_URL}/organizations/createAtSignup`,
            {
              orgName: orgForm.orgName,
              parentOrgId: null,
              members:
                filteredMembers.length > 0
                  ? filteredMembers.map((member) => ({
                      memberEmailId: member.memberEmailId,
                      roleId: member.roleId,
                    }))
                  : [],
              country: null,
              emailId: values.email || emailId,
              website: urlParams ? true : false,
              userPoolId: cognitoId,
            },
          )
          .then((response) => {
            if (response.data === false) {
              setError(true);
              setCreating(false);
            } else {
              setOrgId(response.data?.orgId);
              setBillingForm((prev) => ({
                ...prev,
                address: "",
                country: formattedCountry,
                city: "",
                zipCode: "",
                state: "",
              }));
              setIsBilling(true);
              setCreating(false);
              if (userDetails) {
                getStore().dispatch({ type: Actions.API_ORG_DASHBOARD });
              }
            }
          })
          .catch((error) => {
            setCreating(false);
          });
      } catch (e) {
        setCreating(false);
      }
    }
  };

  const hasErrors = () => {
    const hasDuplicateEmails =
      orgForm.members?.length > 0 &&
      orgForm.members.some((member, index) =>
        orgForm.members
          .slice(index + 1)
          .some(
            (otherMember) => otherMember.memberEmailId === member.memberEmailId,
          ),
      );

    const hasMemberErrors = orgForm.members.some((member) => {
      const emailHasValue = !!member.memberEmailId;
      const isEmailValid =
        emailHasValue && emailRegex.test(member.memberEmailId);
      const roleMissing = !member.roleId;

      return emailHasValue && (!isEmailValid || roleMissing);
    });

    return hasDuplicateEmails || hasMemberErrors;
  };

  const isCreatedisabled =
    (orgForm.orgName !== "" && orgForm.orgName?.length < 4) ||
    nameLoading ||
    orgForm.orgNameError ||
    hasErrors();

  const handleContinue = () => {
    if (step === 1) {
      if (orgForm.orgName !== "") {
        handleCreateOrg();
      } else {
        setBillingForm((prev) => ({
          ...prev,
          address: "",
          country: formattedCountry,
          city: "",
          zipCode: "",
          state: "",
        }));
        if (
          userDetails &&
          orgId === "" &&
          orgForm?.selectOrganization?.value === undefined
        ) {
          setIsAddress(true);
          getStore().dispatch({
            type: Actions.API_GET_ORG_ADDRESS,
            data: { orgId: -1 },
            meta: {
              onSuccess: (data) => {
                setOrgAddress(data);
                setIsAddress(false);
              },
              onError: () => {
                setIsAddress(false);
              },
            },
          });
        }
        setShowMembers(false);
        setIsBilling(true);
        setCreateOrg(false);
      }
    } else setStep(2);
  };

  const updateUserOrgDetails = () => {
    const phNumber =
      formattedCountry === "India"
        ? emailId
          ? userDetails?.phoneNumber
          : "+91" + values.phoneNumber
        : emailId
          ? userDetails?.phoneNumber
          : "+1" + values.phoneNumber;
    try {
      setUpdating(true);
      axios
        .post(
          `${process.env.REACT_APP_BACK_END_API_BASE_URL}/users/updateUserAtSignup?userPoolId=${cognitoId}`,
          {
            emailId: values.email || userDetails?.emailId,
            userName: values.name || userDetails?.userName,
            phoneNumber: phNumber,
            address: billingForm.address,
            country: billingForm.country,
            state: billingForm.state,
            city: billingForm.city,
            zipCode: billingForm.zipCode,
            orgId: organizationId ? organizationId : -1,
          },
        )
        .then((response) => {
          if (response.data === false) {
            setError(true);
            setUpdated(false);
            setUpdating(false);
          } else {
            setStep(2);
            setUpdated(true);
            setUpdating(false);
          }
        })
        .catch((error) => {
          setUpdating(false);
        });
    } catch (e) {
      setUpdating(false);
    }
  };

  const handlePlanSelection = (cycle, price, priceId) => {
    setSelectedPlanDetails({
      billingCycle: cycle,
      planPrice: price,
      priceId: priceId,
    });
    setIsPlanSelected(true);
  };

  const plans = async () => {
    try {
      setPlanLoading(true);
      axios
        .get(`${process.env.REACT_APP_BACK_END_API_BASE_URL}/plans`)
        .then((response) => {
          if (response) {
            setPlansInfo(response.data?.plans);
          }
        })
        .catch(() => {
          setPlanLoading(false);
        });
    } catch (e) {
      setPlanLoading(false);
    }
  };

  const coupon = async () => {
    try {
      setCouponLoading(true);
      // NewPlanSignup is a public route used by both anonymous signups and logged-in
      // users. When logged in, use the authenticated endpoint so the backend can reject
      // a coupon this user already redeemed; otherwise use the public endpoint (an
      // anonymous new user has no prior redemption, and "Bearer null" would 401).
      const accessToken = localStorage.getItem("accessToken");
      const response = await axios.post(
        accessToken
          ? `${process.env.REACT_APP_BACK_END_API_BASE_URL}/plans/plansPrice/user`
          : `${process.env.REACT_APP_BACK_END_API_BASE_URL}/plans/plansPrice`,
        {
          stripe: formattedCountry !== "India",
          coupon: couponCode,
          priceId: priceId,
        },
        accessToken
          ? { headers: { Authorization: "Bearer " + accessToken } }
          : undefined,
      );
      if (response) {
        setPlanLoading(false);
        setCouponLoading(false);
        setIsData(response?.data);
        setAppliedCoupon(couponCode);
        setYearlyPrice(response?.data?.yearlyPrice);
        setIndDiscount(response?.data?.couponDiscountResponse?.amountOff);
        setGst(response?.data?.gstAmount);
        setPfAmount(response?.data?.platformDisc);
        setSubTotal(response?.data?.subTotal);
        setTotal(response?.data?.totalAmount);
        if (indDiscount !== 0) setCouponApplied(true);
      }
      if (response?.data?.couponDiscountResponse?.amountOff === null || 0) {
        setCouponError(true);
      }
    } catch (e) {
      setPlanLoading(false);
      setCouponLoading(false);
      setCouponError(true);
      setIsData((prev) =>
        prev
          ? { ...prev, couponDiscountResponse: { validity: false } }
          : prev,
      );
    }
  };

  useEffect(() => {
    plans();
  }, []);

  const PlanIcon = planName && planIcon[planName];

  const currentPlansData =
    hostingType === "kubernetes"
      ? plansInfo?.licenses
      : plansInfo?.dedicatedPlans;

  const selectedPlan = currentPlansData?.find(
    (plan) =>
      plan.licenseType === planName && plan.isSingleSitePlan === singleSite,
  );

  const noOfSites = selectedPlan?.features?.find(
    (type) => type.type === "NUM_SITES",
  );

  const pricingArray = Array.isArray(newPlan?.pricing)
    ? newPlan.pricing
    : Array.isArray(selectedPlan?.pricing)
      ? selectedPlan?.pricing
      : [];

  const monthlyPricing = pricingArray?.find(
    (price) => price.billingType === "Monthly",
  );
  const yearlyPricing = pricingArray?.find(
    (price) => price.billingType === "Yearly",
  );
  const selectedPricing = pricingArray?.find(
    (price) => price.billingType === billingCycle,
  );

  const priceId = selectedPricing?.stripePriceId;

  useEffect(() => {
    if (plansInfo === null) setPlanLoading(true);
    if (priceId) {
      coupon();
    }
  }, [priceId, formattedCountry]);

  const monthPrice =
    formattedCountry === "India"
      ? monthlyPricing?.orginalPrice_INR
      : monthlyPricing?.originalprice;
  const yearPrice =
    formattedCountry === "India"
      ? yearlyPricing?.orginalPrice_INR
      : yearlyPricing?.originalprice;

  const yearAmount = (monthPrice * 12).toFixed(2);

  const platformDiscount = convertToYearlyPrice(monthPrice) - yearPrice;

  let domain = window.location.hostname;
  domain =
    domain === "localhost" ? process.env.REACT_APP_METADATA_DOMAIN : domain;

  useEffect(() => {
    if (
      emailId &&
      currentUser &&
      (hasPlanData?.hasPlan ||
        hasPlanData === true ||
        domain !== process.env.REACT_APP_FRONTEND_DOMAIN)
    ) {
      navigate("/account/organizations-overview");
    }
  }, [hasPlanData, domain, emailId, currentUser]);

  const openPlanPage = () => {
    if (explorePlans) {
      window.open(
        "https://roconpaas.com/managed-wordpress-hosting-pricing/",
        "_blank",
      );
    } else {
      setExplorePlans(true);
    }
  };

  const handleOnCancel = () => {
    setExplorePlans(false);
  };

  const onChange = (value) => {
    setCaptchaToken(value);
    setRecaptcha(true);
    setError(null);
  };

  const handleOpenCreate = () => {
    const resetOrgForm = {
      orgName: "",
      members: [],
      selectOrganization: {},
    };

    if (!isBilling) {
      setSelectOrg((prev) => !prev);
    } else if (orgData?.length > 0) {
      setIsBilling(false);
      setSelectOrg(true);
    } else {
      setIsBilling(false);
      setIsCreateOrg(true);
    }

    setOrgAddress(null);

    setOrgForm((prev) => ({
      ...prev,
      ...resetOrgForm,
    }));
  };

  const handleToggleMembers = () => {
    setShowMembers(!showMembers);
    if (!showMembers) {
      setOrgForm((prev) => ({
        ...prev,
        members: [{ memberEmailId: "", roleId: "" }],
        memberError: [{ memberEmailIdError: false, roleIdError: false }],
      }));
    }
  };

  const handleMemberEmailChange = (email, index) => {
    email = email.replace(/\s/g, "");
    const updatedMembers = [...orgForm.members];
    updatedMembers[index].memberEmailId = email;

    const updatedMemberErrors = [...orgForm.memberError];
    updatedMemberErrors[index] = {
      ...updatedMemberErrors[index],
      // Set error to false if the email is empty, or validate if not empty
      memberEmailIdError: email ? !emailRegex.test(email) : false,
    };

    if (index === 0 && email === "") {
      updatedMembers[index].roleId = "";
    }

    // Check for duplicate email only if email is not empty
    const isDuplicate =
      email &&
      orgForm.members.some(
        (invite, i) => invite.memberEmailId === email && i !== index,
      );

    if (isDuplicate) {
      updatedMemberErrors[index].memberEmailIdError = true;
    }

    setOrgForm((prevState) => ({
      ...prevState,
      members: updatedMembers,
      memberError: updatedMemberErrors,
    }));
  };

  const handleRoleChange = (role, index) => {
    const updatedMembers = [...orgForm.members];
    updatedMembers[index].roleId = role;

    const updatedMemberErrors = [...orgForm.memberError];
    updatedMemberErrors[index] = {
      ...updatedMemberErrors[index],
      roleIdError: !role,
    };

    setOrgForm((prevState) => ({
      ...prevState,
      members: updatedMembers,
      memberError: updatedMemberErrors,
    }));
  };

  //add email input box
  const addInviteInput = () => {
    if (orgForm.members?.length === 6) {
      orgForm.limitError = "Limit reached";
      return;
    }
    const hasDuplicateEmails =
      orgForm.members?.length > 0 &&
      orgForm.members.some((member, index) =>
        orgForm.members
          .slice(index + 1)
          .some(
            (otherMember) => otherMember.memberEmailId === member.memberEmailId,
          ),
      );
    if (!hasDuplicateEmails)
      setOrgForm((prevState) => ({
        ...prevState,
        members: [...prevState.members, { memberEmailId: "", roleId: "" }],
        memberError: [
          ...prevState.memberError,
          { memberEmailIdError: false, roleIdError: false },
        ],
      }));
  };

  // Remove email input box
  const removeInviteInput = (index) => {
    setOrgForm((prevState) => ({
      ...prevState,
      members: prevState.members.filter((_, i) => i !== index),
      memberError: prevState.memberError.filter((_, i) => i !== index),
    }));
  };
  const stripePayment = async () => {
    try {
      setUpdating(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACK_END_API_BASE_URL}/stripe/createPLSubAtSignup`,
        {
          couponId: couponCode,
          orgId: organizationId ? organizationId : -1,
          priceId: priceId,
          emailId: values.email || emailId,
          userPoolId: cognitoId,
        },
      );

      if (!response.data) {
        setError(true);
        setUpdating(false);
      } else {
        const newLink = response.data?.link;
        window.open(newLink, "_blank");
        setUpdating(false);
        setShowPaymentSuccess(true);
      }
    } catch (error) {
      console.error("Stripe Payment Error:", error);
      setError(true);
    } finally {
      setUpdating(false);
    }
  };

  const cashfreeSubscriptionSessionIdDecrypt = async (sessionId) => {
    let checkoutOptions = {
      subsSessionId: sessionId.replace(/^["']|["']$/g, ""),
      redirectTarget: "_blank",
    };
    const cashfree = await load({
      mode: "sandbox", //or production
    });

    cashfree.subscriptionsCheckout(checkoutOptions).then((result) => {
      if (result.error) {
        // This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
        console.log(
          "User has closed the popup or there is some payment error, Check for Payment Status",
        );
        console.log(result.error);
      }
      if (result.redirect) {
        // This will be true when the payment redirection page couldnt be opened in the same window
        // This is an exceptional case only when the page is opened inside an inAppBrowser
        // In this case the customer will be redirected to return url once payment is completed
        console.log("Payment will be redirected");
      }
      if (result.paymentDetails) {
        // This will be called whenever the payment is completed irrespective of transaction status
        console.log("Payment has been completed, Check for Payment Status");
        console.log(result.paymentDetails.paymentMessage);
      }
    });
  };

  const cashfreePayment = async () => {
    try {
      setUpdating(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BACK_END_API_BASE_URL}/cashfree/createSubscriptionAtSignup`,
        {
          coupon: couponCode ? couponCode : "",
          orgId: organizationId ? organizationId : -1,
          priceId: priceId,
          emailId: values.email || emailId,
          userPoolId: cognitoId,
        },
      );

      if (!response.data) {
        setError(true);
        setUpdating(false);
      } else {
        const cleanedData = response.data.replace(/\\/g, "").trim();
        if (subTotal === 0) {
          setUpdating(false);
          setShowPaymentSuccess(true);
        } else if (cleanedData) {
          cashfreeSubscriptionSessionIdDecrypt(cleanedData);
          setUpdating(false);
          setShowPaymentSuccess(true);
        } else {
          setError(true);
        }
        setUpdating(false);
      }
    } catch (error) {
      console.error("Cashfree Payment Error:", error);
      setUpdating(true);
    } finally {
      setUpdating(false);
    }
  };

  const handleContinueSummary = () => {
    if (step === 1 && !isFullOrgAddress) {
      updateUserOrgDetails();
    } else handlePayment();
  };

  const handlePayment = () => {
    if (country === "India") {
      setIsIndPayment(true);
    } else stripePayment();
  };

  const formCreateAccountBillingErrors = {
    address: billingForm.addressNameError,
    country: billingForm.countryError,
    city: billingForm.cityError,
    state: billingForm.stateError,
    zipCode: billingForm.zipCodeError,
    companyName: billingForm.companyNameError,
    taxID: billingForm.taxIdError,
  };

  const formCreateAccountBillingErrorMessages = {
    address:
      billingForm.addressNameError === true
        ? billingForm.addressNameErrorMessage
        : "",
    country:
      billingForm.countryError === true ? billingForm.countryErrorMessage : "",
    city: billingForm.cityError === true ? billingForm.cityErrorMessage : "",
    state: billingForm.stateError === true ? billingForm.stateErrorMessage : "",
    zipCode:
      billingForm.zipCodeError === true ? billingForm.zipCodeErrorMessage : "",
    companyName: billingForm.comapnyNameErrorMessage,
    taxID: billingForm.taxIdErrorMessage,
  };

  const formCreateAccountErrors = {
    name: values.nameState === "error" ? values.nameState : "",
    phoneNumber:
      values.phoneNumberState === "error" ? values.phoneNumberState : "",
    email:
      values.emailState === "error"
        ? values.emailState
        : emailError
          ? emailError
          : "",
    password: values.passwordState === "error" ? values.passwordState : "",
  };

  const formCreateAccountrrorMessages = {
    name: values.nameState === "error" ? values.nameErrorMessage : "",
    phoneNumber:
      values.phoneNumberState === "error" ? values.phoneNumberErrorMessage : "",
    email:
      values.emailState === "error"
        ? values.emailErrorMessage
        : emailError
          ? "User Already Exists!"
          : "",
    password:
      values.passwordState === "error" ? values.passwordErrorMessage : "",
  };

  const renderCreateOrgSection = () => {
    return (
      <>
        <CreateOrgSignup
          formFieldUpdate={formFieldUpdate}
          orgName={orgForm.orgName}
          setOrgName={(value) => formFieldUpdate("orgName", value)}
          nameLoading={nameLoading}
          suffix={
            orgForm.orgName.length > 0 ? (
              nameLoading ? (
                <CircularProgress size={20} />
              ) : nameValid ? (
                <CheckCircleOutlineOutlinedIcon style={{ color: "green" }} />
              ) : !nameValid ? (
                <HighlightOffIcon style={{ color: "red" }} />
              ) : null
            ) : null
          }
          isCreateOrg={isCreateOrg}
          setIsCreateOrg={setIsCreateOrg}
          orgData={orgData}
          orgForm={orgForm}
          setOrgForm={setOrgForm}
          handleMemberEmailChange={handleMemberEmailChange}
          roleOptions={roleOptions}
          handleRoleChange={handleRoleChange}
          addInviteInput={addInviteInput}
          limitError={orgForm.members?.length === 5 && orgForm.limitError}
          removeInviteInput={removeInviteInput}
          isBilling={isBilling}
          handleContinue={handleContinue}
          handleOpenCreate={handleOpenCreate}
          nameError={orgForm.orgNameError}
          verifying={creating}
          selectOrg={selectOrg}
          setSelectOrg={setSelectOrg}
          isCreatedisabled={isCreatedisabled}
          userDetails={userDetails}
          updated={updated}
          showMembers={showMembers}
          handleToggleMembers={handleToggleMembers}
        />
        <CreateAccountBilling
          formFieldUpdate={formFieldUpdate}
          billingForm={billingForm}
          isBilling={isBilling}
          errors={formCreateAccountBillingErrors}
          errorMessages={formCreateAccountBillingErrorMessages}
          updated={updated}
          billingInValid={billingInValid}
          isFullOrgAddress={isFullOrgAddress}
          isAddress={isAddress}
        />
      </>
    );
  };

  return planLoading ? (
    <Grid2 className={styles.loadingContainer}>
      <OrgOverviewPageLoading />
    </Grid2>
  ) : (
    <>
      <Grid2 className={styles.NewPlanSignupContainer}>
        <Grid2 className={styles.mainContainer}>
          <Grid2 className={styles.label}>
            {step === 2 ? "Your Product" : userDetails ? "Buy Plan" : "Sign Up"}
          </Grid2>
          <Grid2 className={styles.flexBox}>
            <Grid2 className={styles.steps}>
              {emailId !== undefined && !hasPlanData ? (
                <>
                  <SignUpPlan
                    icon={<PlanIcon />}
                    planName={planName}
                    step={step}
                    monthPrice={monthPrice || 0}
                    yearPrice={yearPrice || 0}
                    noOfSites={noOfSites?.limitOrAvailablity}
                    otherPlans={openPlanPage}
                    planImages={PlanIcon}
                    planType={planType}
                    setPlanType={setPlanType}
                    toggleType={toggleType}
                    setToggleType={setToggleType}
                    licenseInfo={currentPlansData}
                    newPlan={newPlan}
                    setNewPlan={setNewPlan}
                    setPlanPrice={selectedPlanDetails}
                    explorePlans={explorePlans}
                    setExplorePlans={setExplorePlans}
                    country={formattedCountry}
                    initialPlan={selectedPlan}
                    onPlanSelect={handlePlanSelection}
                    onCancel={handleOnCancel}
                    userDetails={userDetails}
                    setIsData={setIsData}
                    setCouponCode={setCouponCode}
                    setShowInput={setShowInput}
                    billingCycle={billingCycle}
                    hostingType={hostingType}
                    setHostingType={setHostingType}
                  />
                  {renderCreateOrgSection()}
                </>
              ) : (
                <>
                  {step === 1 && (
                    <Grid2>
                      {userDetails?.emailId === undefined && (
                        <CreateAccount
                          formFieldUpdate={formFieldUpdate}
                          phoneNumberformat={PhoneNumberformat}
                          name={values.name}
                          phoneNumber={values.phoneNumber}
                          email={values.email}
                          password={values.password}
                          errors={formCreateAccountErrors}
                          errorMessage={formCreateAccountrrorMessages}
                          isChecked={isChecked}
                          setIsChecked={setIsChecked}
                          otp={otp}
                          setOtp={setOtp}
                          handleOtpChange={handleOtpChange}
                          handleOtpKeyDown={handleOtpKeyDown}
                          inputRefs={inputRefs}
                          isOtpSent={isOtpSent}
                          sendOtp={handleSendOtp}
                          resendOtp={resendOtp}
                          resendMessage={resendMessage}
                          otpError={otpError}
                          resendLoading={resendLoading}
                          verifyError={verifyError}
                          emailError={emailError}
                          verifyAccount={submitHandler}
                          isCreateOrg={isCreateOrg}
                          verifying={verifying}
                          country={formattedCountry}
                          onChange={onChange}
                          recaptcha={recaptcha}
                          userDetails={userDetails}
                          verified={verified}
                        />
                      )}
                      {renderCreateOrgSection()}
                    </Grid2>
                  )}

                  {step === 2 && (
                    <Grid2>
                      <SignUpPlan
                        icon={<PlanIcon />}
                        planName={planName}
                        step={step}
                        monthPrice={monthPrice || 0}
                        yearPrice={yearPrice || 0}
                        noOfSites={noOfSites?.limitOrAvailablity}
                        otherPlans={openPlanPage}
                        planImages={PlanIcon}
                        planType={planType}
                        setPlanType={setPlanType}
                        toggleType={toggleType}
                        setToggleType={setToggleType}
                        licenseInfo={currentPlansData}
                        newPlan={newPlan}
                        setNewPlan={setNewPlan}
                        setPlanPrice={selectedPlanDetails}
                        explorePlans={explorePlans}
                        setExplorePlans={setExplorePlans}
                        country={formattedCountry}
                        initialPlan={selectedPlan}
                        onPlanSelect={handlePlanSelection}
                        onCancel={handleOnCancel}
                        userDetails={userDetails}
                        setIsData={setIsData}
                        setCouponCode={setCouponCode}
                        setShowInput={setShowInput}
                        billingCycle={billingCycle}
                        hostingType={hostingType}
                        setHostingType={setHostingType}
                      />
                      <SignUpAddon icon={<AddonIcon />} />
                    </Grid2>
                  )}
                </>
              )}
            </Grid2>

            <Grid2 className={styles.planSummary}>
              <Grid2>
                <SignUpPlanSummary
                  isSingleSite={singleSite}
                  planName={planName}
                  billingCycle={billingCycle}
                  planPrice={
                    billingCycle === "Yearly" ? yearAmount : monthPrice
                  }
                  yearlyPrice={yearlyPrice}
                  indDiscount={indDiscount}
                  pfAmount={pfAmount}
                  gst={gst}
                  subTotal={subTotal}
                  total={total}
                  couponApplied={couponApplied}
                  platformDiscount={platformDiscount}
                  noOfSites={noOfSites?.limitOrAvailablity}
                  country={formattedCountry}
                  step={step}
                  couponCode={couponCode}
                  setCouponCode={setCouponCode}
                  setCouponError={setCouponError}
                  onApplyCoupon={coupon}
                  appliedCoupon={appliedCoupon}
                  couponError={couponError}
                  couponLoading={couponLoading}
                  loading={updating}
                  handleContinue={handleContinueSummary}
                  isBilling={isBilling}
                  isDisabled={isDisabled}
                  userDetails={userDetails}
                  isData={isData}
                  setIsData={setIsData}
                  showInput={showInput}
                  setShowInput={setShowInput}
                  planLoading={isData}
                  isBillingValid={isBillingValid}
                  isFullOrgAddress={isFullOrgAddress}
                />
              </Grid2>
              <Grid2 className={styles.text}>30-day money-back guarantee</Grid2>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
      <ModalPopup
        trigger={isIndPayment}
        header={"Note"}
        nextpopup={"Pay Now"}
        nextOnClick={() => {
          cashfreePayment();
        }}
        backPopup={"Cancel"}
        backOnClick={() => {
          setIsIndPayment(false);
        }}
        customWidth="750px"
        customPopupLeft="0"
        loading={updating}
      >
        <Grid2
          className={`${styles.imgCenter} ${styles.animatedOvalContainer}`}
        >
          <IndPaymentIcon />
        </Grid2>
        <Grid2 className={styles.decsGap}>
          <Grid2>
            <PointRight />
          </Grid2>
          <Grid2 className={styles.desc}>
            {formatIndianCurrency(pfAmount) !== 0 &&
              billingCycle === "Yearly" && (
                <span>
                  Your discounted monthly price of{" "}
                  <span className={styles.amount}>
                    ₹{formatIndianCurrency(pfAmount?.toFixed(2))}
                  </span>{" "}
                  has been successfully applied.{" "}
                </span>
              )}
            Please note, the amount shown on the next page reflects the maximum
            monthly price that will be charged after your discount period ends.
          </Grid2>
        </Grid2>
        <Grid2 className={styles.decsGap}>
          <Grid2>
            <PointRight />
          </Grid2>
          <Grid2 className={styles.desc}>
            <strong>
              Rest assured, you are not currently paying the max amount shown on
              the next page.
            </strong>{" "}
            If you have any questions or encounter any issues, please don’t
            hesitate to reach out to{" "}
            <span
              className={styles.clickText}
              onClick={() => {
                window.open("https://roconpaas.com/contact-us/", "_blank");
              }}
            >
              Team Rocon
            </span>{" "}
            — we’re always here to assist you!
          </Grid2>
        </Grid2>
      </ModalPopup>
      {showPaymentSuccess && (
        <Grid2 className={styles.successOverlay}>
          <Grid2 className={styles.successCard}>
            <Grid2 className={styles.successIconWrap}>
              <CheckCircleOutlineOutlinedIcon className={styles.successCheckIcon} />
            </Grid2>
            <Grid2 className={styles.successTitle}>
              Account Created Successfully!
            </Grid2>
            <Grid2 className={styles.successSubtitle}>
              Welcome to Rocon. Your account is ready to go.
            </Grid2>
            <Grid2 className={styles.successDetail}>
              {subTotal === 0
                ? "You can now manage your WordPress sites, handle backups and migrations from your dashboard."
                : "Please complete your payment in the new tab that opened. Once payment is confirmed, sign in to access your dashboard."}
            </Grid2>
            <button
              className={styles.successBtn}
              onClick={() => {
                setShowPaymentSuccess(false);
                if (userDetails) {
                  navigate("/account/organizations-overview");
                } else {
                  navigate(
                    `/login${values.email || emailId ? `?email=${encodeURIComponent(values.email || emailId)}` : ""}`,
                  );
                }
              }}
            >
              Go to Dashboard
            </button>
          </Grid2>
        </Grid2>
      )}
    </>
  );
}

export default NewPlanSignup;
